export class companyProfile {
    id!: any;
    name_ar!: string
    name_en!: string
    name!: string
    address!: string
    address_ar!: string
    address_en!: string
    phone_number!: any
    mobile_code!: any
    phone_code!: any
    email!: string
    balance!: balance
    city_name!: string
    city_id!: string
    request_type!: string
    request_by!: string
    num_employees!: number
    // active,suspend,not_verified,expired
    status!: any
    license_number!: any
    license_file_object!: file
    tax_number_object!: any
    tax_number!: any
    created_at!: any
    logo!: string
    package!: Package
    manager!: Manager
    user_id!: any
    numbers!: any
    has_changes!: boolean
    hr_services!: hrService
}

export class file {
    name!: string
    size!: string
    type!: string
    path!: string
    download!: string
}

export class balance {
    points!: number
    Last_transaction_date!: any
}

export class Package {
    name_en!: string
    name_ar!: string
}

export class Manager {
    full_name!: string
    email!: string
    job_title!: string
    mobile_code!: string
    phone_number!: any
    id!: any
}

// Subscription Tab
export enum SubscriptionSortList {
    ASC = "ASC",
    DESC = 'DESC',
    end_date = 'end_date',
}
export class SubscriptionListData {
    data!: {
        total: number;
        list: {
            name_ar: string
            name_en: string
            created_at: any
            start_date: any
            end_date: any
            is_current: boolean
            remaining_number: number
        }[];
    }
}
export class SubscriptionListFilter {
    page!: number
    perPage!: number
    company_id!: any
    sortBy!: any
    sort!: any
    search!: string
    package_id!: any
}

// Employee List Tab
export enum EmployeeSortList {
    ASC = "ASC",
    DESC = 'DESC',
    department_name = "department_name",
    name = "name",
}
export class EmployeeListData {
    data!: {
        total: number;
        list: {
            id: any
            full_name: string
            email: string
            created_at: any
            image: string
            department_name: string
            balance: number
            num_withdraw_points: any
            num_offers: number
            verified: number
        }[];
    }
}
export class EmployeeListFilter {
    page!: number
    perPage!: number
    company_id!: any
    sortBy!: any
    sort!: any
    search!: string
    department_ids_array: string[] = [];
}


// Departments List Tab
export enum DepartmentSortList {
    department_name = "department_name",
    created_at = 'created_at'
}
export class DepartmentListData {
    data!: {
        total: number;
        list: {
            id: any
            department_name: string
            created_at: string
            manager: any
        }[];
    }
}

export class DepartmentListFilter {
    page!: number
    perPage!: number
    company_id!: any
    sort!: any;
    sortBy!: any
    search!: string
}

// Rewarded Points List Tab
export enum RewardedPointsSortList {
    ASC = "ASC",
    DESC = 'DESC',
}
export class RewardedPointsListData {
    data!: {
        total: number;
        list: {
            id: any
            num_points: string
            num_employees: string
            created_at: string
        }[];
    }
}
export class RewardedPointsListFilter {
    page!: number
    perPage!: number
    company_id!: any
    sort!: any;
    sortBy!: any
    search!: string
    start_date!: any
    end_date!: any
    // department_ids_array!: any[]
}

export class hrService {
    department_id_manage_hr_system: any
    hr_department_name: any
    hr_services_enabled_at: any
    is_enabled: any
}